













































import { Component, Prop } from "vue-property-decorator";
import { mixins } from "vue-class-component";

import InlineSpinner from "@/lib/components/InlineSpinner.vue";

import InvoiceRowsMixin from "../invoice-rows.mixin";

@Component({
  components: {
    InlineSpinner,
  },
})
export default class InvoiceTable extends mixins(InvoiceRowsMixin) {
  @Prop({ default: false })
  public readonly isLoading!: boolean;

  @Prop({ default: false })
  public readonly hasError!: boolean;

  public getStatusClass(statusName: string): string {
    if (statusName === "Unpaid") {
      return "-unpaid";
    }

    if (statusName === "Paid") {
      return "-paid";
    }

    return "";
  }
}
